/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import Header2 from "ui/kit/typography/Header2";
import Body from "ui/kit/typography/Body";

const CompletePreviousStepsSection: React.FC = () => {
    return (
        <>
            <Header2>Not Ready</Header2>
            <Body>Please complete the previous steps before continuing.</Body>
        </>
    );
}

export default CompletePreviousStepsSection;
